
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface ProviderWaiver {
  id: string;
  provider_id: string;
  title: string;
  content: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export const useProviderWaivers = (providerId?: string) => {
  return useQuery({
    queryKey: ["provider-waivers", providerId],
    queryFn: async () => {
      if (!providerId) {
        throw new Error("Provider ID is required");
      }

      console.log("Fetching provider waivers for provider:", providerId);
      
      const { data: waivers, error } = await supabase
        .from('provider_waivers')
        .select('*')
        .eq('provider_id', providerId)
        .order('created_at', { ascending: true });

      if (error) {
        console.error('Error fetching provider waivers:', error);
        throw error;
      }

      console.log("Provider waivers fetched:", waivers);
      return waivers as ProviderWaiver[];
    },
    enabled: !!providerId,
  });
};
